import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Error404Icon from 'atoms/Icons/Error404Icon';
import Error404Image from 'atoms/Icons/Error404Image';
import Link from 'atoms/NextLink';
import React from 'react';

import s from './Error.module.scss';

const Error404 = () => {
  return (
    <div className={s.Error}>
      <div className={s.Error__status}>
        <Error404Icon />
      </div>
      <div className={s.Error__msg}>The page you were looking for doesn&apos;t exist</div>
      <Link href="/marketplace">
        <a className={s.Error__back}>
          <ArrowBackIcon className={s.Error__backIcon} />
          Back home
        </a>
      </Link>
      <Error404Image className={s.Error__image} />
    </div>
  );
};

export default Error404;
